import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../api';
import BusinessAnalyticsOverview from './BusinessAnalyticsOverview';
import CompanyVehiclePerformancePage from './CompanyVehiclePerformancePage';
import '../management-module.css';
import '../business-analytics.css';

const todayInIndia = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
const initialRange = () => { const today = todayInIndia(); return { startDate: today.slice(0, 8) + '01', endDate: today }; };

export default function CompanyManagementOverviewPage() {
  const location = useLocation();
  if (location.pathname.endsWith('/performance')) return <CompanyVehiclePerformancePage />;
  return <CompanyManagementOverview />;
}

function CompanyManagementOverview() {
  const [range, setRange] = useState(initialRange);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  const [updatedAt, setUpdatedAt] = useState('');
  useEffect(() => {
    let current = true;
    setSummary(null); setError('');
    if (!range.startDate || !range.endDate || range.startDate > range.endDate) {
      setError('Select a valid start and end date.'); setLoading(false);
      return () => { current = false; };
    }
    setLoading(true);
    api.get('/management/business-analytics/dashboard', { params: { ...range, limit: 1 } })
      .then(overviewResponse => { if (current) { setSummary(overviewResponse.data.summary); setUpdatedAt(new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' })); } })
      .catch(err => { if (current) setError(err.response?.data?.message || 'Unable to load the overview. Please retry.'); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [range, refresh]);
  return <div className="management-module ba-workspace ba-company-overview">
    <div className="ba-overview-top">
      <div className="ba-overview-heading">
        <div><h3>Business Analytics Overview</h3><span>Attendance, fleet activity and spending for your selected period.</span></div>
      </div>
      <div className="ba-overview-filters" aria-label="Overview date filters">
        <label>From<input type="date" value={range.startDate} max={range.endDate} onChange={event => setRange(r => ({ ...r, startDate: event.target.value }))} /></label>
        <label>To<input type="date" value={range.endDate} min={range.startDate} onChange={event => setRange(r => ({ ...r, endDate: event.target.value }))} /></label>
        <div className="ba-filter-actions">
          <button type="button" onClick={() => { const today = todayInIndia(); setRange({ startDate: today, endDate: today }); }}>Today</button>
          <button type="button" onClick={() => setRange(initialRange())}>This month</button>
          <button type="button" disabled={loading} onClick={() => setRefresh(value => value + 1)}>Refresh</button>
        </div>
        {summary && <small>Updated {updatedAt} IST</small>}
      </div>
    </div>
    {error && <div className="management-error" role="alert">{error} <button type="button" onClick={() => setRefresh(value => value + 1)}>Retry</button></div>}
    {loading ? <p className="ba-loading" role="status">Loading database totals…</p> : summary && <><BusinessAnalyticsOverview summary={summary} endDate={range.endDate} /><Link className="ba-performance-link" to={`/company-user/management/performance?startDate=${range.startDate}&endDate=${range.endDate}`}>View vehicle performance <span aria-hidden="true">→</span></Link></>}
  </div>;
}
